"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mp4WsDriver = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const adapter_1 = require("../../../../api/adapter");
const errors_deprecated_1 = require("../../../../internal/errors-deprecated");
const player_1 = require("../../../../internal/player/meow/player");
const bind_1 = require("../../../../internal/utils/bind");
const Audio = tslib_1.__importStar(require("../../state-flow/controls/audio"));
const Playback = tslib_1.__importStar(require("../../state-flow/controls/playback"));
const FlvHttp = tslib_1.__importStar(require("../../state-flow/drivers/mp4-ws"));
const encoding_selectors_1 = require("../encoding-selectors");
const helpers_1 = require("../helpers");
const register_1 = require("../register");
const common_1 = require("./common");
// returns wrapper to make sure that we use native hls
function wrap(fn) {
    const wrapper = (ss, sf) => {
        // check if nativeHls driver is in use
        if (!FlvHttp.InUse.is(sf.mp4ws)) {
            return state_flow_1.Result.ignore();
        }
        return fn(ss, sf);
    };
    Reflect.defineProperty(wrapper, "name", { configurable: true, value: fn.name });
    return wrapper;
}
class Mp4WsDriver {
    constructor(ctx) {
        this.ctx = ctx;
        this.player = null;
        // readonly debugInfo: unknown;
        this.encodingSelector = new encoding_selectors_1.HighestBitrateSelector();
        // metadata: unknown;
        this.availableEncodings = [];
        (0, bind_1.makeBounded)(this);
    }
    get data() {
        var _a, _b;
        return (_b = (_a = this.sf.manifest.json) === null || _a === void 0 ? void 0 : _a.formats["mp4-ws"]) !== null && _b !== void 0 ? _b : null;
    }
    get manifest() {
        var _a, _b;
        const data = (_a = this.sf.manifest.json) === null || _a === void 0 ? void 0 : _a.formats["mp4-ws"];
        if (data == null) {
            return null;
        }
        if (((_b = data.origin) === null || _b === void 0 ? void 0 : _b.location) != null) {
            return data.origin.location;
        }
        if (data.encodings.length > 0) {
            return data.encodings[0].location;
        }
        return null;
    }
    static isManifestSupported(manifest) {
        return (manifest === null || manifest === void 0 ? void 0 : manifest.formats["mp4-ws"]) != null;
    }
    static isHostSupported(host) {
        return (0, common_1.isVideoElement)(host);
    }
    static isPlatformSupported() {
        return adapter_1.device.isImplements(adapter_1.Feature.MPEGTS);
    }
    initStateFlow(sf) {
        this.sf = sf;
        sf.handleEnter(FlvHttp.Prepared, this.prepare);
        sf.handleEnter(FlvHttp.InUse, this.activate);
        sf.handleExit(FlvHttp.InUse, this.deactivate);
        // sf.onCommit(Host.Attached, this.onHostAttached);
        // sf.handleExit(Host.Attached, wrap(this.onHostDetaching));
        sf.handleEnter(Playback.Playing, wrap(this.startPlaying));
        sf.handleExit(Playback.Playing, wrap(this.stopPlaying));
        sf.handleEnter(Audio.UnMuted, wrap(common_1.unmuteVideoElement));
        sf.handleChanges(Audio.UnMuted, wrap(common_1.changeVolumeVideoElement));
        sf.handleExit(Audio.UnMuted, wrap(common_1.muteVideoElement));
    }
    prepare(states) {
        if (adapter_1.device.isImplements(adapter_1.Feature.MPEGTS)) {
            return state_flow_1.Result.transition(adapter_1.device.loadMpegtsScript().then(() => state_flow_1.Result.ok()));
        }
        return state_flow_1.Result.reject("mpegts is not supported");
    }
    activate({ host, manifest }) {
        const el = (0, common_1.getVideoElement)(host.element);
        if (manifest.json == null) {
            throw new Error("manifest is null");
        }
        if (!adapter_1.device.isImplements(adapter_1.Feature.MPEGTS)) {
            throw new Error("mpegts is not supported");
        }
        const format = manifest.json.formats["mp4-ws"];
        const encoding = this.encodingSelector.select((0, helpers_1.parseEncodings)(format));
        if ((encoding === null || encoding === void 0 ? void 0 : encoding.location) == null || encoding.location === "") {
            throw new errors_deprecated_1.DriverNotSupportedError("invalid encoding", {});
        }
        this.player = new player_1.MeowPlayer(this.ctx, this, {}, el);
        return state_flow_1.Result.ok();
    }
    deactivate({ host }) {
        var _a;
        const el = (0, common_1.getVideoElement)(host.element);
        // some cleanup
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.destroy();
        this.player = null;
        el.src = "";
        return state_flow_1.Result.ok();
    }
    startPlaying(states, sf) {
        // that's ok if it throws an error
        // it will be caught by state flow
        return state_flow_1.Result.transition(this.player.play().then(() => state_flow_1.Result.ok()));
    }
    stopPlaying(states, sf) {
        const el = (0, common_1.getVideoElement)(states.host.element);
        el.pause();
        return state_flow_1.Result.ok();
    }
    pickEncoding() {
        var _a, _b;
        return (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.encodings[0]) !== null && _b !== void 0 ? _b : null;
        // const bitrate = null;
        //
        // let encodings = this.data?.encodings ?? [];
        //
        // if (encodings.length === 0) {
        //   return null;
        // }
        //
        // if (bitrate == null) {
        //   return encodings[0];
        // }
        //
        // encodings = encodings.sort((a, b) =>
        //   (a.audioKbps ?? 0) + (a.videoKbps ?? 0) < (b.audioKbps ?? 0) + (b.videoKbps ?? 0) ? 1 : -1,
        // );
        // const bestEncoding = encodings.find((e) => (e.audioKbps ?? 0) + (e.videoKbps ?? 0) <= bitrate);
        //
        // if (bestEncoding != null) {
        //   return bestEncoding;
        // }
        // return encodings[this.currentLevel ?? 0];
    }
    async [Symbol.dispose]() {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.destroy();
    }
}
exports.Mp4WsDriver = Mp4WsDriver;
Mp4WsDriver.displayName = "Mp4WsDriver";
Mp4WsDriver.driverName = "mp4ws";
(0, register_1.registerVideoDrivers)(Mp4WsDriver);
//# sourceMappingURL=mp4-ws.js.map